import { Injectable, OnInit, OnDestroy } from '@angular/core';
import StepIndicatorConfig from 'src/app/shared/interfaces/step-indicator-config';
import { Subscription, Observable } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class MultiStepService implements OnInit, OnDestroy {

    private stps: StepIndicatorConfig[] = [];
    currentStep = 0;
    showIndicator = true;

    private subscriptions: Subscription[] = [];

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) {
        const sub2 = this.router.events.subscribe(evt => {
            if (evt instanceof NavigationEnd) {
                this.computeCurrentStep(evt.url);
            }
        });

        this.subscriptions.push(sub2);
    }

    private computeCurrentStep(eventUrl: string) {
        this.stps.forEach(stp => {
          const stpUrl = stp.url.join('/').replace('//', '/');
          if (stpUrl === eventUrl) {
            this.currentStep = stp.num;
          }
        });
    }

    ngOnInit() {
        this.stps = this.stps || [];
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => {
          if (!s) {
            return;
          }
          s.unsubscribe();
        });
    }

    goToNextStep(): void {
        if (this.currentStep >= this.stps.length) {
            return;
        }
        const step = this.stps[this.currentStep];
        this.router.navigate(step.url, { relativeTo: this.route });
    }

    goToPreviousStep(): void {
        if (this.currentStep <= 1) {
            return;
        }
        const step = this.stps[this.currentStep - 2];
        this.router.navigate(step.url, { relativeTo: this.route });
    }

    setSteps(stps: Observable<StepIndicatorConfig[]>): void {
        stps.subscribe(s => {
            this.stps = s;
            this.computeCurrentStep(this.router.url);
        });
    }

    get steps(): StepIndicatorConfig[] {
        return this.stps;
    }
}
